export default "__VITE_ASSET__BPdHWgrL__"